var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  ref: "pageFrom",
                  attrs: {
                    inline: "",
                    size: "small",
                    model: _vm.pageFrom,
                    "label-position": "right",
                    "label-width": "90px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单编号：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.pageFrom.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "orderNo", $$v)
                            },
                            expression: "pageFrom.orderNo",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.search },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入",
                          size: "small",
                          clearable: "",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.search($event)
                          },
                        },
                        model: {
                          value: _vm.pageFrom.productName,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageFrom, "productName", $$v)
                          },
                          expression: "pageFrom.productName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "核销状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.pageFrom.isWriteOff,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "isWriteOff", $$v)
                            },
                            expression: "pageFrom.isWriteOff",
                          },
                        },
                        _vm._l(_vm.isWriteOffOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.pageFrom.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "status", $$v)
                            },
                            expression: "pageFrom.status",
                          },
                        },
                        _vm._l(_vm.orderStatusOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "店铺类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.pageFrom.storeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.pageFrom, "storeType", $$v)
                            },
                            expression: "pageFrom.storeType",
                          },
                        },
                        _vm._l(_vm.storeTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { label: item.value, value: item.key },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "付款时间：" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "selWidth date-range",
                        attrs: {
                          type: "datetimerange",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "range-separator": "至",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                          clearable: "",
                        },
                        model: {
                          value: _vm.payTimeRange,
                          callback: function ($$v) {
                            _vm.payTimeRange = $$v
                          },
                          expression: "payTimeRange",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "search-actions" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "mr10",
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.search },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr10",
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.exportLoading,
                        disabled: _vm.exportLoading,
                      },
                      on: { click: _vm.exportOrders },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.exportLoading ? "导出中..." : "订单导出") +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.resetSearch },
                    },
                    [_vm._v("重置搜索")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "订单编号", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "order-no" }, [
                          _c("div", { staticClass: "order-no-main" }, [
                            _vm._v(_vm._s(scope.row.orderNo)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "order-product" }, [
                            _vm._v(_vm._s(scope.row.productName || "-")),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商户信息", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "merchant-info" }, [
                          _c("div", [
                            _vm._v(_vm._s(scope.row.merchantName || "-")),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "store-name" }, [
                            _vm._v(_vm._s(scope.row.storeName || "-")),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeTypeName",
                  label: "店铺类型",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "商品名称",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "预约人信息", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            "预约人：" +
                              _vm._s(scope.row.reservationName || "-")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "reservation-phone" }, [
                          _vm._v(
                            "预约电话：" +
                              _vm._s(scope.row.reservationPhone || "-")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "核销状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getWriteOffStatusType(
                                scope.row.isWriteOff
                              ),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getWriteOffStatusText(
                                    scope.row.isWriteOff
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单状态", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getOrderStatusType(scope.row.status),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.statusDesc ||
                                    scope.row.statusName ||
                                    _vm.getOrderStatusText(scope.row.status)
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "金额/积分", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            "订单金额：¥" +
                              _vm._s(_vm.formatPrice(scope.row.totalPrice))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "微信：¥" +
                              _vm._s(_vm.formatPrice(scope.row.paidPrice))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "福豆：¥" +
                              _vm._s(_vm.formatPrice(scope.row.useIntegral))
                          ),
                        ]),
                        _vm._v(" "),
                        Number(scope.row.oneCardDeductPrice) > 0
                          ? _c("div", [
                              _vm._v(
                                "\n            一卡通权益抵扣：¥" +
                                  _vm._s(
                                    _vm.formatPrice(
                                      scope.row.oneCardDeductPrice
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payTime",
                  label: "支付时间",
                  width: "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "下单时间",
                  width: "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "200", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.viewOrder(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _vm._v(" "),
                        scope.row.status == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openVerifyDialog(scope.row)
                                  },
                                },
                              },
                              [_vm._v("核销")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        [2, 3, 10].includes(scope.row.status)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm._refund(scope.row)
                                  },
                                },
                              },
                              [_vm._v("退款")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 50, 100, 200],
                  "page-size": _vm.pageFrom.limit,
                  "current-page": _vm.pageFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("OrderDetail", { ref: "orderDetailRef" }),
      _vm._v(" "),
      _c("VerifyOrderDialog", {
        ref: "verifyOrderDialogRef",
        on: { success: _vm.handleVerifySuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }